import React, {useState, Button, useEffect} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';

import {frontendLocationsActions, alertsActions, useSelector, priceTariffsActions} from "inbooma-api";              // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../utils";               // necessary to communicate with inbooma-react
import {_,moment} from "../../../../../vendor";
import Select from "react-select";
import * as contingentsActions from "inbooma-api/store/contingents/actions";
import Changes from "./Changes";
import JobsSidebar from "./JobsSidebar";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import ContingentsControllerAccessBarMap from "../../../../controllers/ContingentsControllerAccessBarMap";
import {in_array} from "../../../../utils/Helper";

const JobsView = (props) => {

    // initialize resource - set selected resource or set defaults
    const [jobs, setJobs] = useState( props.jobs);
    const [initialized, setInitialized] = useState(false);

    const [notification,setNotification] = useState({
        message: "",
        show: false
    });

    const _getObjectFromArray = (array) => {
        return array.reduce((obj,entity) => {
            obj[entity.id] = entity;
            return obj;
        },{});
    };

    const onSubmit = () => {


    };

    const close = () => {
        props.onClose();
    };
    const forceReInit = () => {
        setTimeout(() => {
            props.dispatch(frontendLocationsActions.getJobs({
                token: Biscuit.get('token')
            }));
        }, 1000);
    };


let normStyle ={
    };
let normStylePadding = {
        fontSize: "100%",
        lineHeight: "1.5",
        color: "#5D687E",
        fontWeight: "normal",
        padding: "10px 0 0 0",
        marginBottom: "0"
    };
let labelStyle = {
    maxWidth: "75%",
    minHeight:"40px",
    height: "0",
    lineHeight: "20px"
};
let labelText = "";
let newArr = {
    margin: "10px 0 10px 0",
    clear:"both",
    padding: "0"
};
let switchStyle={
    minWidth:"50px",
    paddingLeft: "10px"
};
let detailsStyle = {
    marginTop: "0px"
};
const setNormStyles = (key) => {
    if (key === 0){
        normStyle={
            maxWidth:"40%",
            padding: "0"
        };
        labelStyle = {
            maxWidth: "65%",
            minHeight:"40px",
            height: "0",
            minWidth: "65%",
            lineHeight: "20px"
        };
    } else {
        normStyle={
            maxWidth:"30%",
            padding: "0"
        };
        labelStyle = {
            maxWidth: "65%",
            minHeight:"40px",
            height: "0",
            minWidth: "65%",
            lineHeight: "20px"
    };
    }
};
let missings = "", changes = "";
    jobs.map((job, index) => {
        missings = "";
        changes = "";
        job.missingParameters.forEach(function (value, key) {
            if (missings === "") {
                missings = t(value);
            } else {
                missings += ", " + t(value);
            }
        });
        /*if(job.changes !== null){
            let setted="";
            for (const [title, text] of Object.entries(job.changes)) {
                if(changes === ""){
                    changes = '<b>' + title + ":</b><br/><p>      " + text +"</p>";
                }
                if(setted === title){
                    changes += "<p>      " + text + '</p>'
                } else {
                    changes += '<br/><b>' + title + ":</b><br/><p>      " + text +"</p>"
                }
                setted = title;
            }
        }*/
    });


    let tabs =[{
        name: 'ID',
        smallWidth: 2,
        style: {minWidth:'90px'},
        extraClasses: 'medium-20-3',
        title: t('sort_by_${a}',{a:t('ID')},'capital')
    },{
        name: t('name',null,'capital'),
        smallWidth: 2,
        style: {minWidth:'90px'},
        extraClasses: 'medium-20-3',
        title: t('name',null,'capital')
    }, {
        name: t('changes'),
        smallWidth: 4,
        style: {minWidth:'180px'},
        extraClasses: 'medium-4',
        title: t('changes','capital')
    },{
        name: t('missing_parameters',null,'capital'),
        smallWidth: 3,
        style: {minWidth:'180px'},
        extraClasses: 'medium-3',
        title: t('missing_parameters',null,'capital')
    }];
    let submenuItems = props.submenuItems;;
    return (<>
        <JobsSidebar
            dispatch={props.dispatch}
            showNotification={props.showNotification}
            forceReInit={forceReInit}
            setJobs={setJobs}
        />
        <div id="inb-c-main" className="columns">
            <InboomaSubmenu
                tabs={submenuItems}
                searchbar={false}
                smallOnlyTitle={t('frontendChanges',null,'capital')}
            />
            <SortNav
                tabs={tabs}
                handler={null}
            />
                    <div id="inb-c-main-frontend_locations" className="inb-c-listing off-canvas-content" data-off-canvas-content="" style={{paddingTop:'12px'}}>
                        {typeof jobs.map == 'function' && jobs.map((job, index) => {
                            return (
                                <>
                                    <div className={"inb-c-item inb-c-item--frontend_locations row"} key={index}>
                                        <div className="medium-20-3 small-2 column" title={t('job_id',null,'capital')} style={{minWidth:'90px'}}>
                                            <span>{job.id}</span>
                                        </div>
                                        <div className="medium-20-3 small-2 column" title={t('name',null,'capital')} style={{minWidth:'90px'}}>
                                            <span>{job.name}</span>
                                        </div>
                                        <div className="medium-4 small-4 column" title={t('changes',null,'capital')} style={{minWidth:'180px'}}>
                                            <Changes
                                                changes={job.changes}
                                                />
                                        </div>
                                        <div className="medium-3 small-3 column" title={t('missing_parameters',null,'capital')} style={{minWidth:'180px'}}>
                                            <span>{missings}</span>
                                        </div>
                                    </div>
                                </>
                            )}
                        )}
                    </div>
        </div>


</>
    );
};

export default JobsView;